import type { Transition, Variants } from 'framer-motion';

/**
 * Shared spring config used across every motion element in the sidebar.
 * Critically damped (low bounce) for a smooth, non-jittery glide.
 */
export const SIDEBAR_SPRING: Transition = {
  type: 'spring',
  visualDuration: 0.55,
  bounce: 0.04,
};

/**
 * Variants for label-style elements (text labels, story name).
 * Width animation collapses the element so it doesn't take horizontal space when hidden.
 */
export const LABEL_VARIANTS: Variants = {
  hidden: { opacity: 0, x: -6, width: 0 },
  shown: { opacity: 1, x: 0, width: 'auto' },
};

/**
 * Variants for fixed-height section labels (Discover, Setup, Current Story header).
 * Don't collapse width — the label sits in its own row.
 */
export const SECTION_LABEL_VARIANTS: Variants = {
  hidden: { opacity: 0, x: -4 },
  shown: { opacity: 1, x: 0 },
};
